import { styled } from 'styled-components'

import { Button } from '../../../GenderFunnel/Button/Button'
import { Typography } from '../../../Typography'

export const StyledWrapper = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 1rem 0;
`

export const StyledContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0.25rem;
  border: 1px solid ${({ theme }) => theme.colors['N Surface/Primary']};
  border-radius: ${({ theme }) => theme.radius['Radius FULL']}px;
  backdrop-filter: blur(0.25rem);
  background: ${({ theme }) => theme.colors['N Surface/BG Blur Base']};
  box-shadow: 0 0 1.5rem 0 rgba(0, 0, 0, 0.16);
  gap: 0.25rem;
`

export const StyledCountdownContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
  padding-left: 1rem;
`

export const StyledCountdownTypography = styled(Typography).attrs({
  as: 'div',
})`
  font-variant-numeric: tabular-nums;
`

export const StyledCountdownDescriptionTypography = styled(Typography).attrs({
  as: 'div',
})`
  hyphens: auto;
  text-wrap: balance;
`

export const StyledCtaButton = styled(Button)`
  align-self: stretch;
`
